export default __webpack_public_path__ + "static/media/tete65.96e739b5.png";